import { AddIcon, Button, Dropdown, WidgetSizeEnum } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

// Reusable component for adding a transaction, currently used in TransactionsList.jsx

interface AddTransactionButtonProps {
  onAddRevenue: () => void;
  onAddExpense: () => void;
}

export function AddTransactionButton({ onAddRevenue, onAddExpense }: AddTransactionButtonProps) {
  const { t } = useTranslation();
  return (
    <Dropdown
      data-testid="add-transaction-dropdown"
      items={[
        {
          label: t('transactions.addMenu.expenseOption'),
          onClick: onAddExpense,
          extraClasses: 'data-testid-add-expense-option',
        },
        {
          label: t('transactions.addMenu.revenueOption'),
          onClick: onAddRevenue,
          extraClasses: 'data-testid-add-revenue-option',
        },
      ]}
    >
      <Button
        data-testid="add-transaction-button"
        primary
        size={WidgetSizeEnum.SMALL}
        postIcon={<AddIcon className="size-5" />}
      >
        {t('transactions.addMenu.buttonLabel')}
      </Button>
    </Dropdown>
  );
}
